import React from "react";
import { BaseTabedPage } from "../../../../_metronic/layout/components/common/baseTabedPage";
import FormTypePage from "./FormTypePage";
import FormPage from "./FormPage";
import AnswerPage from "./AnswerPage";
import AnswerOfQuestionPage from "./AnswerOfQuestionPage";
import QuestionPage from "./QuestionPage";

const components = [
  {
    id: 2,
    title: "ویرایش پرسشنامه ها",
    url: "/forms",
    tab: "forms",
    component: FormPage,
  },
  {
    id: 3,
    title: "مدیریت پرسش ها",
    url: "/questions",
    tab: "questions",
    component: QuestionPage,
  },
  {
    id: 4,
    title: "مدیریت پاسخ ها",
    url: "/answers",
    tab: "answers",
    component: AnswerPage,
  },
  {
    id: 5,
    title: "مدیریت پرسش-پاسخ",
    url: "/answerQuestions",
    tab: "answerQuestions",
    component: AnswerOfQuestionPage,
  },
  {
    id: 1,
    title: "پرسشنامه ها ",
    url: "/formTypes",
    tab: "formTypes",
    component: FormTypePage,
  },
];

export const FormBasePage = () => {
  return <BaseTabedPage components={components} basePath="/form" />;
};
